
import React from 'react';
import ChatInterface from '../chat/ChatInterface';
import { Message } from '../chat/ChatInterface';
import { AIAgent } from '@/hooks/useCareerChat';

interface ChatTabProps {
  messages: Message[];
  isTyping?: boolean;
  onSendMessage: (message: string) => Promise<void>;
  agent?: AIAgent | null;
}

const ChatTab: React.FC<ChatTabProps> = ({
  messages,
  isTyping = false,
  onSendMessage,
  agent
}) => {
  // Create a wrapper function that returns a Promise
  const handleSendMessage = async (message: string): Promise<void> => {
    return onSendMessage(message);
  };

  return (
    <ChatInterface
      messages={messages}
      isTyping={isTyping}
      onSendMessage={handleSendMessage}
      placeholder="Ask about career options, skills to develop, or job market trends..."
      agent={agent}
    />
  );
};

export default ChatTab;
